<div fxLayout="column">
    <fieldset class="bordas">

        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>

            <mat-form-field fxFlex="50%" style="margin-top: 80px;" fxFlexOffset="20px">
                <mat-label>Parceiro:</mat-label>
                <mat-select [(ngModel)]="parceriasPrograma.empresa.id" name="empresa" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let e of empresas" [value]="e.id">
                        {{e.nomeRazaoSocial}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="empresas?.length === 0" align="start">Nenhum parceiro cadastrado</mat-hint>
            </mat-form-field>

            <mat-form-field  style="margin-top: 20px;" fxFlex="50%" fxFlexOffset="20px" appearance="outline">
                <mat-label>Tipo de Parceria:</mat-label>
                <textarea #descricaoTipoParceria matInput name="descricaoTipoParceria"
                    [(ngModel)]="parceriasPrograma.dsTipoParceria" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="50" required></textarea>
                <mat-hint align="end">{{descricaoTipoParceria.value.length}} / 50</mat-hint>
            </mat-form-field>

        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                <input matInput name="dtImplantacao" 
                      [matDatepicker]="dataInicio" 
                      placeholder="Data de entrada:"
                      (input)="onMascaraDataInput($event)"
                      [(ngModel)]="parceriasPrograma.dtInicioParceria" required>
                <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                <mat-datepicker #dataInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="15%">
                <input matInput name="dtTermino" [matDatepicker]="dataTermino" 
                       placeholder="Data de saída:"
                       (input)="onMascaraDataInput($event)"
                       [(ngModel)]="parceriasPrograma.dtFimParceria">
                <mat-datepicker-toggle matSuffix [for]="dataTermino"></mat-datepicker-toggle>
                <mat-datepicker #dataTermino></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="15%" fxFlexOffset="20px">
                <input currencyMask matInput maxlength="50" name="valorParceria" placeholder="Valor da parceria:"
                    [(ngModel)]="parceriasPrograma.valorParceria"
                    [options]="{ prefix: '', thousands: '.', decimal: ',' }" 
                    precision=2
                    />
                <span matPrefix>R$&nbsp;</span>
            </mat-form-field>
        </div>


        <div style="margin-left: 20px;" *ngIf="parceriasPrograma.aditivosParceriasProgramas.length > 0">
            Aditivos:
        </div>
          
            <div fxLayout="column" *ngIf="parceriasPrograma.aditivosParceriasProgramas.length > 0" fxFlexFill>
                <div *ngFor="let aditivo of parceriasPrograma.aditivosParceriasProgramas;index as i" fxFlexFill>
                        <mat-form-field fxFlexOffset="40px" fxFlex="25%">
                            <input [(ngModel)]="aditivo.dataAditivo" matInput [ngModelOptions]="{standalone: true}"
                                   [matDatepicker]="dataMovimentacao" 
                                   placeholder="Data do Aditivo" 
                                   (input)="onMascaraDataInput($event)"
                                   required>
                            <mat-datepicker-toggle matSuffix [for]="dataMovimentacao">
                            </mat-datepicker-toggle>
                            <mat-datepicker #dataMovimentacao></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field fxFlexOffset="40px" fxFlex="25%">
                            <input [(ngModel)]="aditivo.valorAditivo" currencyMask [ngModelOptions]="{standalone: true}"
                                placeholder="Valor do Aditivo:" matInput maxlength="13"
                                [options]="{ prefix: '', thousands: '.', decimal: ',' }" required />
                            <span matPrefix>R$&nbsp;</span>
                        </mat-form-field>

                        <button mat-button (click)="deletarAditivo(parceriasPrograma,aditivo)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

            </div>

            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10%; margin-bottom: 10%" fxFlexFill>
                <button mat-button style="margin-top: 1%;" (click)="adicionarAditivo(parceriasPrograma)">
                    <mat-icon>addchart</mat-icon>
                    novo aditivo.
                </button>
            </div>
       
    </fieldset>
</div>